import find from 'lodash/find';
import { useSelector } from 'react-redux';

const useCompareDeviceName = () => {
  const sites = useSelector((state) => state.sites.data);
  const meters = useSelector((state) => state.meters.data);
  const inverters = useSelector((state) => state.inverters.data);
  const sensors = useSelector((state) => state.sensors.data);

  const findDevice = (deviceId) => {
    switch (deviceId.split(':')[0]) {
      case 'site':
        return find(sites, { site_id: deviceId });
      case 'meter':
        return find(meters, { meter_id: deviceId });
      case 'inverter':
        return find(inverters, { inverter_id: deviceId });
      case 'sensor':
        return find(sensors, { sensor_id: deviceId });
      default:
        return null;
    }
  };

  return (deviceId1, deviceId2) => {
    const device1 = findDevice(deviceId1);
    const device2 = findDevice(deviceId2);
    return device1?.name < device2?.name ? -1 : 1;
  };
};

export default useCompareDeviceName;
